module.exports = __webpack_public_path__ + "static/img/bg-es.7ef16cc3.webp";